import React from "react";
import { BiCheckCircle } from "react-icons/bi";

const CancelComplete = () => {
  return (
    <div className="sm:min-w-screen md:max-w-[400px] mx-auto min-h-screen flex flex-col justify-center items-center bg-white py-4">
      <div className="flex flex-col items-center">
        {/* <FontAwesomeIcon icon={faCheckCircle} size="3x" className="text-green-500 mb-4" /> */}
        <BiCheckCircle size="4rem" className="text-[#3e9ff9] mb-8" />
        {/* <img src="/assets/img/logo1.png" className="w-[150px] h-[47px] object-cover mb-4" /> */}
        <span className="text-2xl font-bold text-center text-[#535353] mt-8 mb-8">신청취소가 완료되었습니다.</span>
      </div>
    </div>

    // <div className="sm:min-w-screen md:max-w-[375px] mx-auto min-h-screen  flex justify-center relative overflow-hidden bg-white ">
    //   <div className="w-full absolute mx-auto top-[326px] text-sm font-bold text-center text-[#535353]">
    //     <br />
    //     <span className="w-full text-xl font-bold text-center text-[#535353]">신청취소가 완료되었습니다</span>
    //   </div>

    //   <div className="flex flex-col justify-start items-center w-full absolute left-0 top-[148px] gap-3 py-[25px]">
    //     <img src="/assets/img/logo1.png" className="flex-grow-0 flex-shrink-0 w-[150px] h-[47px] object-cover" />
    //   </div>
    // </div>
  );
};

export default CancelComplete;
